<div class="usan-form-item sequence-structural-info-oligonucleotides-short-peptides-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ wasFileUploaded ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column flex-wrap">
      <span class="usan-form-item sequence-item sequence-text" [innerHTML]="title">
      </span>
      <div class="break"></div>
      <div class="usan-form-item sequence-item sequence-text" *ngIf="isFormBType">
        <ul>
          <li>The full nucleotide sequence of the substance in the following format: 50 nucleotides per line, in blocks of 10, with numbering at the end of each line (Word or in the text of an email)</li>
          <li>The nucleotide sequence should be annotated to delineate relevant parts of the sequence (e.g., coding regions, control regions)</li>
          <li>A schematic map of the entire nucleic acid showing inserted/deleted gene(s) and relevant functional parts (not required for short oligonucleotides)</li>
        </ul>
      </div>
      <div class="usan-form-item sequence-item sequence-text" *ngIf="isFormDType">
        <ul>
          <li>The full nucleotide sequence of the substance in the following format: 50 nucleotides per line, in blocks of 10, with numbering at the end of each line (Word or in the text of an email)</li>
          <li>The nucleotide sequence should be annotated to delineate relevant parts of the sequence (e.g. coding regions, control regions)</li>
          <li>A schematic map of the entire nucleic acid showing inserted/deleted gene(s) and relevant functional parts (not required for short oligonucleotides)</li>
        </ul>
      </div>
      <div class="usan-form-item sequence-item sequence-text" *ngIf="isFormFType">
        <ul>
          <li>The full nucleotide sequence of the substance in the following format: 50 nucleotides per line, in blocks of 10, with numbering at the end of each line in a format that can be copied (Word or in the text of an e-mail). The nucleotide sequence should be annotated to delineate relevant parts of the sequence (e.g., coding regions, control regions).</li>
          <li>A table of features providing an overview of the relevant parts of the sequence (not required for short oligonucleotides). The table should contain the annotation, a description of the annotation, the position and the color code used in the sequence. Where a new vector is derived from an existing one, a sequence alignment and table of comparison should be provided.</li>
          <li>A schematic map of the entire nucleic acid showing inserted/deleted gene(s) and relevant functional parts (not required for short oligonucleotides). For cell-based gene therapy substances, please consult the “Cell-based therapies” information sheet.</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-sequence-structural-info-oligonucleotides-short-peptides form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload sequence
    </button>
  </div>
  <ng-container *ngIf="wasFileUploaded">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>